type Props = {};

const PageUpdates = (props: Props) => {
  return <div>PageUpdates</div>;
};

export default PageUpdates;
